"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Accordion", {
    enumerable: true,
    get: function() {
        return Accordion;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _renderAccordion = require("./renderAccordion");
const _useAccordion = require("./useAccordion");
const _useAccordionContextValues = require("./useAccordionContextValues");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useAccordionStylesstyles = require("./useAccordionStyles.styles");
const Accordion = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useAccordion.useAccordion_unstable)(props, ref);
    const contextValues = (0, _useAccordionContextValues.useAccordionContextValues_unstable)(state);
    (0, _useAccordionStylesstyles.useAccordionStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useAccordionStyles_unstable')(state);
    return (0, _renderAccordion.renderAccordion_unstable)(state, contextValues);
});
Accordion.displayName = 'Accordion';
